import {SelectableCorpAccount} from '@/components/global/layout/EventBar/useOrderAccounts';

export const getCorpDisplayName = (corpAccount: SelectableCorpAccount | undefined) =>
  corpAccount?.displayName ?? corpAccount?.name ?? '';
